/* eslint-disable no-unused-vars */
import { DEGREE, STATUS, WEBINAR_STATUS } from "@types";
import { RequestMeta } from ".";
import {
  DetailsExpire,
  ICartInput,
  Pagination,
  PaginationData,
} from "./common";
import { DifficultyLevel } from "@modules/course/access/access-interview-questions/DifficultyIcon";
import { FESTIVAL_TYPE } from "enums/festival-type";
import {
  ApiProductCardImages,
  ApiProductCoverImages,
  ApiProductFeaturedImages,
  ApiProductSeoImages,
  ApiProductThumbnailImages,
  ExternalCoverImages,
} from "./product-image";

export interface RelatedProduct {
  id: string;
  title: string;
  url?: string;
  png_image: string;
  svg_image?: string;
  webp_image?: string;
}
export interface CourseContent {
  has_file: boolean;
  has_pdf: boolean;
  has_reference: boolean;
}
export interface CourseTag {
  id: number;
  name: string;
  slug: string;
}
export type ParentCourse = {
  name: string;
  url: string;
};
export type CourseLanguages = "fa" | "en" | "Persian" | "English";

//must be change name
export enum LESSON_STEP_TYPE {
  TEXT = "text",
  PRACTICE = "practice",
  EXAMPLE = "example",
  GENERAL = "general",
  SINGLE_QUESTION = "single_question",
  QUIZ = "quiz",
  EXAM = "exam",
  NOTE = "note",
  FAQ = "faq",
  GLOSSARY = "glossary",
  RELATED_JOB = "related_job",
  INTERVIEW_QUESTIONS = "interview_questions",
  SUMMARY_NOTE = "summary_note",
}

export type StepSection = {
  duration: number;
  end: string; // example: "00:00:03"
  end_seconds: string; // "3"
  start: string; // "00:00:02"
  start_seconds: string; // "2"
  title: string;
  thumbnail?: string;
};

export type KeyMomentDataType = {
  duration: number;
  end: string;
  end_seconds: number;
  start: string;
  start_seconds: number;
  thumbnail: string;
  title: string;
};

export type StepInfo = {
  created_at: string;
  deleted_at?: string;
  description?: string;
  download_link: string;
  duration: string;
  product_id: number;
  lesson_id: string;
  size: string;
  subtitle?: string | null;
  title: string;
  online_link: string;
  online_link_480: string;
  online_link_720?: string;
  online_link_1080?: string;
  online_title: string;
  id: number;
  instructor_notes?: string;
  is_demo: boolean;
  is_free: boolean;
  files_download_link?: string | null;
  files_size?: string | number;
  heading?: string | null;
  heading_id?: string | null;
  note: string | null;
  notes_download_link: string | null;
  notes_size: string | null;
  updated_at: string;
  videos_download_link: string | null;
  videos_size: string | null;
  online_link_s3: null | string;
  online_link_480_s3: null | string;
  status_price: string;
  video_checksum: string;
  video_checksum_480: null;
  open_for_guest: boolean;
  type: LESSON_STEP_TYPE;
  question_count?: number;
  sections: StepSection[];
  key_moments?: KeyMomentDataType[];
};

export interface StepInfoText extends StepInfo {
  type: LESSON_STEP_TYPE.TEXT | LESSON_STEP_TYPE.SINGLE_QUESTION;
  extra_file_size?: string | null;
  file_url?: string | null;
  file_size: string | null;
  extra_note?: string | null;
  extra_file_url?: string | null;
  extra_title?: string | null;
  name?: string;
  meta: null | {
    singleQuestion: {
      answer1: string;
      answer2: string;
      answer3: string;
      answer4: string;
      correctAnswer: string;
    };
  };
  summary_note?: string | null;
}
export interface StepInfoExam extends StepInfo {
  type: LESSON_STEP_TYPE.QUIZ | LESSON_STEP_TYPE.GENERAL;
  min_point?: number;
  question_count?: number;
  questions_time?: number;
  random_questions?: boolean;
  retry_exam?: boolean;
  retry_exam_day?: number;
  status?: STATUS;
}

export enum LESSON_BUTTONS_LABEL {
  DOWNLOAD = "دانلود",
  EDIT = "ویرایش",
  REMOVE = "حذف",
}

export interface LessonItemData {
  label: LESSON_BUTTONS_LABEL;
  icon: React.ReactNode;
  onClick: () => void;
}
export interface LessonStep {
  type: LESSON_TYPE;
  subtitle: null;
  name: string;
  id: number;
  duration: string;
  info: StepInfo | FaqItemDataType[] | GlossaryItemDataType[];
  hasNote?: boolean;
  watch_percent: number;
  is_constant: boolean;
}
export type SingleVideoURL = {
  download_link: string;
  title: string;
};
export type SingleDownloadURL = {
  size: string;
  urls: SingleVideoURL[];
};
export interface CourseDownloadLinks {
  file_download_url?: {
    size: string;
    url: string;
  };
  note_download?: {
    size: string;
    url: string;
  };
  tools_download?: {
    size: string;
    url: string;
  };
  total_download_url?: {
    size: string;
    url: string;
  };
  video_download?: {
    size: string;
    url: string;
  };
  single_download_url: SingleDownloadURL;
}

export interface OriginalLesson {
  name: string;
  not_numbering: boolean;
  is_constant: boolean;
  steps: LessonStep[];
}
export type IndexedLesson = OriginalLesson & {
  index: number | null;
  counter?: number | null;
};
export type Prerequisite = {
  id: number;
  object_id: number;
  title: string;
  type: "software" | "course" | "search" | "landing";
  url: string | null;
};

export type SoftwarePerquisite = {
  title: string;
  url: null | string;
  type: "software";
};
///must be change
export type CoursePack = Omit<productCard, "slug"> & {
  type: COURSE_TYPE;
  instructors: {
    first_name: string;
    last_name: string;
  }[];
  count_instructors?: number;
  count_child_products?: number;
};
export interface productCard extends ApiProductCardImages {
  id: number;
  title: string;
  title_short?: string;
  url: string;
  slug: string;
  price: number;
  duration: {
    hours: number;
    in_minutes: number;
    minutes: number;
    rounded_in_hour: number;
  };
  excerpt: string;
  instructors: CourseInstructor[];
  demo_from_steps: boolean;
  is_favorite: boolean;
  is_buy: boolean;
  watchTime_Percent: number;
  attribute_type: COURSE_TYPE;
  type: COURSE_TYPE;
  status: STATUS;
  is_in_cart: boolean;
}
export interface ICourseCard {
  data?: {
    instructor_products: productCard[];
    recommended_products?: productCard[];
    confidence_score: number;
    package_instructors: instructorCard[];
    related_packages: CoursePack[];
    relatedProducts?: productCard[];
  };
}

export interface instructorCard {
  id: number;
  instructor_caption: string;
  profile_picture: string;
  first_name: string;
  last_name: string;
  degree: DEGREE;
  special_field: string;
  show_special_description: number;
  field: string;
  slug: string;
  product_count: number;
}
export interface ICourse {
  product: ProductCourse;
  user: UserCourse;
  lessons: StepInfo[];
  original_lessons: OriginalLesson[];
}

export enum FESTIVAL_KIND {
  PERCENTAGE = "درصدی",
  WONDER = "شگفتی",
  STEPPED = "پلکانی",
}

export type PhysicalImage = { name: string; url: string };

export type ProductCourse = ApiProductThumbnailImages &
  ApiProductFeaturedImages &
  ApiProductCoverImages &
  ApiProductSeoImages & {
  // huge_products?: [];
  // huge_old_price?: string;
  id: number;
  title: string;
  ext_title_short: null;
  sku: string;
  svg_icon: string;
  attribute_type: COURSE_TYPE;
  progress_status: string;
  status: STATUS;
  price: number;
  isbn: null;
  language: CourseLanguages;
  published_at: string;
  created_at: string;
  seo_title: string;
  seo_metadesc: string | null;
  add_extra_detail_after_order: string | null;
  extra_field_status: number;
  sold_count: number;
  prerequisites: Prerequisite[];
  product_prerequisites: (ICartInput | SoftwarePerquisite)[];
  product_view: number;
  size: string;
  practiceCount: number;
  examCount: number;
  download_links?:
    | {
        single_download?: { url: string; size: string };
        note_download?: { url: string; size: string };
        note_attachments_url?: { type: string; url: string; name: string }[];
        file_download?: { url: string; size: string };
        total_download_url?: { url: string; size: string };
        total_download?: { url: string; size: string };
        tools_download: { url: string; size: string };
        video_download?: { url: string; size: string };
      }
    | [];
  faqs:
    | []
    | {
        answer: string;
        answer_google: string;
        question: string;
        question_google: string;
        status: "inactive" | "active";
      }[]; ///may be change not found real course for get type ==> TODO: I Changed this to old type. must be dabble check!
  is_free: boolean;
  product_route_type: string;
  description_data: {
    list: string;
    description: string;
    good_for: string;
    achievements?: string | null;
    achievements_strip?: string | null;
    good_for_strip: string;
  };

  slug: string;
  cover_video: {
    "720": string;
    "480": string;
  };
  instructors: CourseInstructor[];
  excerpt: string;
  duration: {
    hours: number;
    in_minutes: number;
    minutes: number;
    rounded_in_hour: number;
    lessons: string;
  };
  is_draft: boolean;
  categories: CourseCategory[];
  course_content: CourseContent;
  lessons_count: number;
  parent_course: ParentCourse | null;
  rating: {
    rate: number;
    total: number;
  };
  preview?: CoursePreview;
  webinar?: Webinar;
  tags?: {
    id: number;
    name: string;
    slug: string;
  }[];
  estimated_publish_time?: string; /// publishing course
  festival?: {
    discount?: string;
    festival_kind: FESTIVAL_KIND;
    festival_type: string;
    price_after_discount: number;
  };
  package: {
    is_package: boolean;
    is_huge: boolean;
    sub_products: CoursePack[];
  };
  jobCount: number;
  commentCount: number;
  favoriteCount: number;
  price_after_package_discount: number;
  child_product_count: number;
  discount_package: number;
  instructor_count: number;
  auxiliary_product: {
    inventory: number;
    items: string[];
    medias: { id: number; name: string; url: string }[];
    title: string;
  };
  has_auxiliary_product: boolean;
  fara_festival?: {
    total_price: number;
    total_discount: number;
    price_after_discount: number;
    discount: number;
    is_percent: boolean;
    discount_value: number;
    festival_type: FESTIVAL_TYPE;
    festival_title: string;
    festival_slug: string;
    expire_time: string;
    expire_str: string;
  };
  hasCertificate: boolean;
  klo: keyLearningItem[];

  external_cover_images?: ExternalCoverImages;
  details_expire?: DetailsExpire;

  supplementary_content_counts: SupplementaryCounts;
};

export type SupplementaryCounts = {
  course_lecture_note: number;
  course_summary: number;
  faq: number;
  glossary: number;
  interview_questions: number;
  key_moments: number;
  lecture_note: number;
  related_jobs: number;
  summary: number;
  transcript: number;
};

export type keyLearningItem = {
  id: number;
  product_id: number;
  objective: string;
  priority: number;
  created_at: string;
  updated_at: string;
};

export type Webinar = {
  webinar_lesson_count: number;
  webinar_signup_active: boolean;
  webinar_status: WEBINAR_STATUS;
  webinar_time?: {
    start_at: string;
    end_at: string;
    duration_sec: number;
  }[];
};

export type UserCourse = {
  in_cart: boolean;
  is_buy: boolean;
  is_favorite: boolean;
  is_organization: boolean;
  is_instructor: boolean;
  // items below has in logged in user mode
  organization_name?: string;
  is_notify_on_publish?: boolean; /// for isPublishing course
  rating?: {
    rate: 1 | 2 | 3 | 4 | 5 | null;
  };
  watch_times?: {
    total: number;
    lessons: {
      id: number;
      duration: string;
      last_time_second: null;
      updated_at: null;
    }[];
  };
  comments?: {
    user_has_comment: boolean;
    user_has_approved_comment: boolean;
  };
};

export type CoursePreviewSteps = {
  id: number;
  subtitle: string | null;
  online_title: string;
  duration: string;
  status_price: string;
  is_free: boolean;
  open_for_guest: boolean;
  online_link?: string | null;
  download_link?: string | null;
  online_link_480?: string | null;
  files_download_link?: string | null;
  type?: LESSON_STEP_TYPE;
  name?: string;
};

export type StepPreviewCourseItem = {
  id: number | null;
  collectionTitle: string;
  title: string;
  videoSources: { label: string; url: string }[];
  subtitleSrc: string | null;
};

export type CoursePreview = {
  show_demo: boolean;
  description_list: string | null;
  demos: StepInfo[] | [];
  collections: {
    active_demo: 0 | 1;
    all_demo: 0 | 1;
    expanded: boolean;
    name: string;
    not_numbering: boolean;
    steps: CoursePreviewSteps[] | [];
  }[];
};

export type CourseInstructor = {
  first_name: string;
  last_name: string;
  slug: string;
  instructor_caption: string;
  biography_excerpt: string;
  biography_excerpt_noHtml: string;
  profile_picture: string;
  degree: DEGREE;
  special_field: string;
  show_special_description: 0 | 1;
  field: string | null;
  total_count: number;
  total_duration: number;
  total_students: number;
};
export type CourseCategory = {
  id: number;
  name: string;
  parent: number;
  slug: string;
  pivot: {
    product_id: number;
    category_id: number;
  };
};

export interface ICourseResult {
  status: boolean;
  data: ICourse;
}
export interface ICourseParams {
  showProduct?: 0 | 1;
  recache?: 0 | 1;
  mode?: string;
}
export type CourseCommentsInitial = {
  comments: ICourseComment[];
  total: number;
  loadMore: boolean;
};
export interface ICourseCommentsResult {
  status: boolean;
  data: ICourseComment[];
  pagination: Pagination;
}

export interface ICourseNote {
  id: number;
  lesson_id: number;
  note: string;
  product_id: number;
  time: string;
}
export interface ICourseNotesResult {
  status: boolean;
  data: ICourseNote[];
  pagination: Pagination;
}
export type CourseCommentRole = "user" | "instructor";
export interface ICourseComment {
  children: ICourseComment[];
  created_at: string;
  id: number;
  message: string;
  name: string;
  role: CourseCommentRole;
  isConfirm?: boolean;
}
export interface ICourseCommentData extends PaginationData {}
export interface IPostCommentInput {
  comment_post_ID: string;
  comment_parent?: string;
  comment?: string;
  rating?: 1 | 2 | 3 | 4 | 5;
}
export interface CoursePostCommentOutput {
  data: { comment: { id: number } };
  message: string;
  status: boolean;
}

export interface ICourseQuestionResult {
  status: boolean;
  data: ICourseQuestion[];
  pagination: Pagination;
}

export interface ICourseLikeDislikeQuestionResult {
  status: boolean;
  message: string;
}

export interface CreateQAInput {
  content: string;
  parent_id?: number;
  title?: string;
}
export interface EditQAInput {
  content: string;
  title: string;
}
export interface CreateQAOutput {
  data: { question_id: number };
  message: string;
  status: boolean;
}

export interface ICourseQuestion {
  replies: ICourseQuestion[];
  created_at: string;
  id: number;
  content: string;
  status: string;
  parent_id?: number;
  likes_count: number;
  isTeacher?: boolean;
  user: {
    id: number;
    first_name: string;
    last_name: string;
  };
  isLikedByCurrentUser: boolean;
  isAdmin: boolean;
  showMessage?: boolean;
  title: string;
  editable: boolean;
}

export interface ICourseQuestionData extends PaginationData {}
export interface StepWatchTimeInput {
  product_id: string;
  lesson_id: string;
  duration: number;
  time: number;
}
export interface GuestStepWatchTimeInput {
  product_id: string;
  lesson_id: string;
  duration: number;
  time: number;
  session_id: string | number;
}
export interface CreateNoteInput {
  note: string;
  product_id: number;
  lesson_id: number;
  time: string;
}
export interface CreateNoteOutput {
  data: {
    id: number;
    note: string;
    lesson_id: number;
    product_id: number;
    time: string;
  };
  message: string;
  status: boolean;
}

export interface RateOutput {
  message: string;
  product_rating: number;
  status: boolean;
}
export interface ToggleFavOutput {
  message: string;
  status: boolean;
  type: "create" | "delete";
}

export interface DeleteQuestionOutput {
  message: string;
  status: boolean;
}

export interface IPreviewPackCourse {
  status: boolean;
  data: {
    product: {
      preview: CoursePreview;
      collection_statistics: {
        collections_count: number;
        total_lessons_count: number;
      };
    };
  };
}

export interface StepPreviewItem {
  [key: number]: {
    id: number | null;
    collectionTitle: string;
    title: string;
    videoSources: { label: string; url: string }[];
    time?: string;
    subtitleSrc: string | null;
  };
}
//must be change name
export enum COURSE_TYPE {
  COURSE = "course",
  WEBINAR = "webinar",
  BLIND = "blind",
  PODCAST = "podcast",
  AUDIOBOOK = "audiobook",
  PACK = "pack",
  EXAM = "exam",
  SERVICES = "service",
  PACKAGE = "package",
  NOTE = "note",
  PRACTICE = "practice",
  PHYSICAL = "physical",
  TEXT = "text",
  BOOK = "book",
  VIDEO = "video",
}

export enum EXTEND_COURSE_TYPE {
  BLOG = "blog",
}

export type WatchTimeData = {
  lastWatchedTime: number;
  watchedDuration: number;
  lastWatchedPercent: number;
  req?: RequestMeta<void, StepWatchTimeInput, never>;
};

export type GlossaryItemDataType = {
  created_at: string;
  definition: string;
  id: number;
  product_id: number;
  term_in_english: string;
  term_in_persian: string;
  updated_at: string;
};

export type FaqItemDataType = {
  answer: string;
  created_at: string;
  id: number;
  product_id: number;
  question: string;
  updated_at: string;
};

export type RelatedJobItemDataType = {
  created_at: string;
  id: number;
  job_description: string;
  job_title_in_english: string;
  job_title_in_persian: string;
  product_id: number;
  relationship_to_course: string;
  updated_at: string;
};

export type InterviewQuestionItemDataType = {
  category: string;
  created_at: string;
  difficulty_level: DifficultyLevel;
  id: number;
  model_answer: string;
  product_id: number;
  question: string;
  relevance: string;
  updated_at: string;
};

export enum LESSON_TYPE {
  EXAM = "exam",
  LESSON = "lesson",
  NOTE = "note",
  LECTURE_NOTE = "lecture_note",
  GLOSSARY = "glossary",
  FAQ = "faq",
  RELATED_JOBS = "related_job",
  INTERVIEW_QUESTIONS = "interview_questions",
  SUMMARY_NOTE = "summary_note",
}

export enum SORT_NOTE {
  NEWEST = "newest",
  OLDEST = "oldest",
}

export enum SORT_ALL_NOTE {
  FIRST = "first",
  LAST = "last",
}
